import { CustomRouter } from "@utils/router";
import { ValidarAssinaturaPage } from './validar-assinatura.page';

export class ValidarAssinaturaRoutes {
    static register(router: typeof CustomRouter) {
        router.add('validar-assinatura', () => {
            const body = document.body;
            body.innerHTML = ValidarAssinaturaPage.render();
            ValidarAssinaturaPage.mount();
        });
    }
}
